module.exports = __webpack_public_path__ + "static/img/miyazawa_04.129c766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/miyazawa_04.png
// module id = 1xVR
// module chunks = 0